import React from "react";
import { openConsentManager } from "@segment/consent-manager";
import { Button } from "@hopper/button";
import inEU from "@segment/in-eu";

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer>
      <div className="text-left pl-sm">
        <span className="pr-sm">
          <strong>Copyright</strong> Tester Work &copy;
          {currentYear}
        </span>
        {inEU() && (
          <Button appearance="minimal" type="button" onClick={openConsentManager} className="pl-0">
            Website Data Collection Preferences
          </Button>
        )}
      </div>
    </footer>
  );
};

export default Footer;
